export default "__VITE_ASSET__B2Bj6Wbq__"